/**
 * Centralized tracking events catalog
 * Following industry naming conventions (snake_case)
 */

export const TRACKING_EVENTS = {
  // Hotel Refunds
  HOTEL_REFUND_SHOWN: "hotel_refund_shown",
  HOTEL_REFUND_CLICKED: "hotel_refund_clicked",
  HOTEL_REFUND_CLAIM_INITIATED: "hotel_refund_claim_initiated",
  HOTEL_REFUND_CLAIM_SUBMITTED: "hotel_refund_claim_submitted",
  HOTEL_REFUND_CLAIM_SUCCESS: "hotel_refund_claim_success",
  HOTEL_REFUND_CLAIM_FAILED: "hotel_refund_claim_failed",

  // Product Refunds
  PRODUCT_REFUND_SHOWN: "product_refund_shown",
  PRODUCT_REFUND_CLICKED: "product_refund_clicked",
  PRODUCT_REFUND_CLAIM_INITIATED: "product_refund_claim_initiated",
  PRODUCT_REFUND_CLAIM_SUBMITTED: "product_refund_claim_submitted",
  PRODUCT_REFUND_CLAIM_SUCCESS: "product_refund_claim_success",
  PRODUCT_REFUND_CLAIM_FAILED: "product_refund_claim_failed",

  // Subscription Refunds
  SUBSCRIPTION_REFUND_SHOWN: "subscription_refund_shown",
  SUBSCRIPTION_REFUND_CLICKED: "subscription_refund_clicked",
  SUBSCRIPTION_REFUND_CLAIM_INITIATED: "subscription_refund_claim_initiated",
  SUBSCRIPTION_REFUND_CLAIM_SUBMITTED: "subscription_refund_claim_submitted",
  SUBSCRIPTION_REFUND_CLAIM_SUCCESS: "subscription_refund_claim_success",
  SUBSCRIPTION_REFUND_CLAIM_FAILED: "subscription_refund_claim_failed",

  // Flight Refunds
  FLIGHT_REFUND_SHOWN: "flight_refund_shown",
  FLIGHT_REFUND_CLICKED: "flight_refund_clicked",
  FLIGHT_REFUND_CLAIM_INITIATED: "flight_refund_claim_initiated",
  FLIGHT_REFUND_CLAIM_SUBMITTED: "flight_refund_claim_submitted",
  FLIGHT_REFUND_CLAIM_SUCCESS: "flight_refund_claim_success",
  FLIGHT_REFUND_CLAIM_FAILED: "flight_refund_claim_failed",

  // Unclaimed Money/Property
  UNCLAIMED_MONEY_SHOWN: "unclaimed_money_shown",
  UNCLAIMED_MONEY_CLICKED: "unclaimed_money_clicked",
  UNCLAIMED_MONEY_CLAIM_INITIATED: "unclaimed_money_claim_initiated",
  UNCLAIMED_MONEY_CLAIM_SUBMITTED: "unclaimed_money_claim_submitted",
  UNCLAIMED_MONEY_CLAIM_SUCCESS: "unclaimed_money_claim_success",
  UNCLAIMED_MONEY_CLAIM_FAILED: "unclaimed_money_claim_failed",
  UNCLAIMED_PROPERTY_MONITORING_STARTED:
    "unclaimed_property_monitoring_started",

  // Class Action Suits
  CLASS_ACTION_SHOWN: "class_action_shown",
  CLASS_ACTION_CLICKED: "class_action_clicked",
  CLASS_ACTION_CLAIM_INITIATED: "class_action_claim_initiated",
  CLASS_ACTION_CLAIM_DOWNLOADED: "class_action_claim_downloaded",
  CLASS_ACTION_CLAIM_SUBMITTED: "class_action_claim_submitted",
  CLASS_ACTION_CLAIM_SUCCESS: "class_action_claim_success",
  CLASS_ACTION_CLAIM_FAILED: "class_action_claim_failed",

  // Credit Card Offers
  CREDIT_CARD_OFFER_SHOWN: "credit_card_offer_shown",
  CREDIT_CARD_OFFER_CLICKED: "credit_card_offer_clicked",
  CREDIT_CARD_OFFER_VIEWED: "credit_card_offer_viewed",
  CREDIT_CARD_OFFER_EXTERNAL_LINK_CLICKED:
    "credit_card_offer_external_link_clicked",

  // Bank Account Offers
  BANK_OFFER_SHOWN: "bank_offer_shown",
  BANK_OFFER_CLICKED: "bank_offer_clicked",
  BANK_OFFER_VIEWED: "bank_offer_viewed",
  BANK_OFFER_EXTERNAL_LINK_CLICKED: "bank_offer_external_link_clicked",

  // AdGem Offers (Signup Offers)
  ADGEM_OFFER_SHOWN: "adgem_offer_shown",
  ADGEM_OFFER_CLICKED: "adgem_offer_clicked",
  ADGEM_OFFER_DETAILS_VIEWED: "adgem_offer_details_viewed",
  ADGEM_OFFER_CLAIM_INITIATED: "adgem_offer_claim_initiated",
  ADGEM_OFFER_PAYMENT_CHECK_REQUIRED: "adgem_offer_payment_check_required",
  ADGEM_OFFER_CLAIM_SUCCESS: "adgem_offer_claim_success",
  ADGEM_OFFER_CLAIM_FAILED: "adgem_offer_claim_failed",

  // Bill Negotiator
  BILL_NEGOTIATOR_SHOWN: "bill_negotiator_shown",
  BILL_NEGOTIATOR_CLICKED: "bill_negotiator_clicked",
  BILL_NEGOTIATOR_UPLOAD_STARTED: "bill_negotiator_upload_started",
  BILL_NEGOTIATOR_BILL_UPLOADED: "bill_negotiator_bill_uploaded",
  BILL_NEGOTIATOR_NEGOTIATION_INITIATED:
    "bill_negotiator_negotiation_initiated",
  BILL_NEGOTIATOR_NEGOTIATION_SUCCESS: "bill_negotiator_negotiation_success",
  BILL_NEGOTIATOR_NEGOTIATION_FAILED: "bill_negotiator_negotiation_failed",

  // User Engagement Events
  FEED_REFRESHED: "feed_refreshed",
  FEED_SCROLLED: "feed_scrolled",
  OFFER_HIDDEN: "offer_hidden",
  OFFER_SHARED: "offer_shared",

  // Referral & Growth Events
  SIGNUP_WITH_REFERRAL: "signup_with_referral",
  REFERRAL_CODE_COPIED: "referral_code_copied",
  REFERRAL_PAGE_VIEWED: "referral_page_viewed",
  REFERRAL_INVITE_SENT: "referral_invite_sent",

  // Authentication Events
  GMAIL_LINKED: "gmail_linked",
  USER_SIGNED_IN: "user_signed_in",
  USER_SIGNED_UP: "user_signed_up",
  USER_SIGNED_OUT: "user_signed_out",
  PASSWORD_RESET_REQUESTED: "password_reset_requested",

  // Payment Events
  PAYMENT_METHOD_ADDED: "payment_method_added",
  PAYMENT_METHOD_FAILED: "payment_method_failed",
  PAYMENT_METHOD_REMOVED: "payment_method_removed",

  // Onboarding & Screen Views
  APP_LAUNCHED: "app_launched",
  WELCOME_SCREEN_VIEWED: "welcome_screen_viewed",
  WELCOME_SLIDE_VIEWED: "welcome_slide_viewed",
  GET_STARTED_CLICKED: "get_started_clicked",
  SIGN_IN_CLICKED: "sign_in_clicked",
  ONBOARDING_STARTED: "onboarding_started",
  ONBOARDING_STEP_COMPLETED: "onboarding_step_completed",
  ONBOARDING_COMPLETED: "onboarding_completed",
  HOME_FEED_VIEWED: "home_feed_viewed",
  PROFILE_VIEWED: "profile_viewed",
  SETTINGS_VIEWED: "settings_viewed",

  // App Rating & Review Events
  RATE_US_SCREEN_VIEWED: "rate_us_screen_viewed",
  RATE_US_BUTTON_CLICKED: "rate_us_button_clicked",
  RATE_US_SKIPPED: "rate_us_skipped",
  RATE_US_NATIVE_AVAILABLE: "rate_us_native_available",
  RATE_US_CUSTOM_RATING_SUBMITTED: "rate_us_custom_rating_submitted",
  RATE_US_FALLBACK_URL_OPENED: "rate_us_fallback_url_opened",
} as const;

export type TrackingEvent =
  (typeof TRACKING_EVENTS)[keyof typeof TRACKING_EVENTS];
